import React from 'react';
import { CartBundleFooterApplePayButton } from './CartBundleFooterApplePayButton';
import CheckoutPayPalButton from './CheckoutPayPalButton';
import CartStartCheckoutButton from './CartStartCheckoutButton';
import { CheckoutErrorAlertBox } from './CheckoutErrorAlertBox';
import {
  core_apimessages_Money as Money,
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
} from '../../src/schemas/rql';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';

interface Props {
  paymentMethodType: CheckoutPaymentMethodType;
  checkoutPath: string;
  currency: string;
  checkoutBundlingId: string;
  applePayCheckoutBundlingId: string;
  amountTotal: Money;
  adyenCheckoutPaymentMethodsConfig: string;
}

export default function CheckoutCartFooterButtons(props: Props) {
  const [errors, setErrors] = React.useState([]);
  const showPaypalCheckoutButton = useExpEnabled(experiments.PAYPAL_CHECKOUT_BUTTON);
  const isDirectCheckout = props.paymentMethodType === CheckoutPaymentMethodType.DIRECT_CHECKOUT;

  return (
    <>
      {errors.length > 0 &&
        <div className="mb-2">
          <CheckoutErrorAlertBox errors={errors} />
        </div>
      }
      <div className="checkout-cart-footer__buttons">
        <CartStartCheckoutButton
          paymentMethodType={props.paymentMethodType}
          checkoutPath={props.checkoutPath}
        />
        {showPaypalCheckoutButton &&
          <CheckoutPayPalButton
            currency={props.currency}
            checkoutBundlingId={props.checkoutBundlingId}
            setErrors={setErrors}
          />}
        {isDirectCheckout &&
          <CartBundleFooterApplePayButton
            checkoutBundlingId={props.applePayCheckoutBundlingId}
            amountTotal={props.amountTotal}
            adyenCheckoutPaymentMethodsConfig={props.adyenCheckoutPaymentMethodsConfig} />}
      </div>
    </>
  );
}
